import { GraphChartConfigDto, PitcherSessionReportChartConfigDto, ChartType } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig = PitcherSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<GraphChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  chartKey: keyof TReportConfig;
};

const PlayerLineChartSidebar = <T extends ReportConfig>({ extraChartData, setTempLayout, tempLayout, chartId, chartKey }: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId as ChartType, extraChartData)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={extraChartData.availableStats}
        selected={extraChartData.yAxis}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [chartKey]: {
              ...tempLayout[chartKey],
              yAxis: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

const PitcherSessionTimelineChartSidebar_1 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerLineChartSidebar chartKey='pitcherSessionTimelineChartConfig_1' chartId='PitcherSessionTimelineChart_1' {...props} />;
};

const PitcherSessionTimelineChartSidebar_2 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerLineChartSidebar chartKey='pitcherSessionTimelineChartConfig_2' chartId='PitcherSessionTimelineChart_2' {...props} />;
};

const PitcherSessionTimelineChartSidebar_3 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerLineChartSidebar chartKey='pitcherSessionTimelineChartConfig_3' chartId='PitcherSessionTimelineChart_3' {...props} />;
};

const PitcherSessionTimelineChartSidebar_4 = (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return <PlayerLineChartSidebar chartKey='pitcherSessionTimelineChartConfig_4' chartId='PitcherSessionTimelineChart_4' {...props} />;
};

export {
  PitcherSessionTimelineChartSidebar_1,
  PitcherSessionTimelineChartSidebar_2,
  PitcherSessionTimelineChartSidebar_3,
  PitcherSessionTimelineChartSidebar_4,
};
